import { FC } from "react"
import { useMobCard } from "@/hooks/useMobCard"
import { MobCardView } from "@/modals/constructor/mobs/MobCardModal/ui"
import { useModal } from "@/modals/hooks"
import { Modal } from "@/ui/Modal"
import styles from "./MobCardModal.module.scss"

const modalType = "mobCard"

export const MobCardModal: FC = () => {
  const { modal, getModalParams } = useModal(modalType)
  const view = useMobCard(getModalParams(modalType))

  return (
    <Modal.Fullscreen type={modalType} className={styles.raise}>
      <MobCardView {...view} onClose={modal.close} />
    </Modal.Fullscreen>
  )
}
